export function numberToPtBrLocaleString(number) {

    let numberFormatted = parseFloat(number)

    return numberFormatted.toLocaleString('pt-BR');
}